import { cognitoUserPoolsTokenProvider as Pe } from "aws-amplify/auth/cognito";
import { CookieStorage as ve } from "aws-amplify/utils";
import { jsx as n, jsxs as d } from "react/jsx-runtime";
import { signOut as j, fetchAuthSession as Se, fetchUserAttributes as Ee, getCurrentUser as Ie, signInWithRedirect as he, confirmSignIn as ce, signIn as be } from "aws-amplify/auth";
import { createContext as _e, useState as s, useEffect as V, useContext as Ce } from "react";
import { Stack as g, Group as z, Icon as Re, Text as D, Container as Te, AssetWatchLogo as Le, Title as le, Alert as Ae, Input as x, Checkbox as Ne, Button as L, InlineLink as ke } from "@assetwatch/ui";
import { post as Oe } from "aws-amplify/api";
const J = "NikolaTeam";
function Ue(e) {
  if (!e?.trim())
    return !1;
  const r = e.trim();
  return r === J ? !0 : r.split(/[,;]/).map((o) => o.trim()).some((o) => o === J);
}
function it(e) {
  return e ? Ue(e.role) ? !0 : e.cognitoGroups.includes(J) : !1;
}
const ue = {
  prod: {
    USER_POOL_ID: "us-east-2_MqZrrppS1",
    APP_CLIENT_ID: "7phcejhgai3vf6rj7mr526akc",
    IDENTITY_POOL_ID: "us-east-2:9ea0609d-9c44-4356-ae9e-6d38aa1898a1",
    DOMAIN: "auth-idp.assetwatch.com"
  },
  qa: {
    USER_POOL_ID: "us-east-2_tGB8JmQO3",
    APP_CLIENT_ID: "30ajgh20k1njb80coevmf9v1kr",
    IDENTITY_POOL_ID: "us-east-2:e6134d6f-3cbb-4c0f-a61a-7e1e184a4e59",
    DOMAIN: "auth-idp.qa.qa.assetwatch.com"
  },
  dev: {
    USER_POOL_ID: "us-east-2_x7NmjJEZB",
    APP_CLIENT_ID: "3urf9oqfossk0dv7eacrkl4p4h",
    IDENTITY_POOL_ID: "us-east-2:f2b106f4-7e58-4fe5-9576-59bfdd75cfe0",
    DOMAIN: "auth-idp.dev.dev.assetwatch.com"
  }
}, xe = [
  "USER_POOL_ID",
  "APP_CLIENT_ID",
  "IDENTITY_POOL_ID",
  "DOMAIN"
];
function at({
  allowFallback: e = !1,
  deployEnvironment: r,
  injectedConfig: o
}) {
  const a = xe.map((t) => [t, o?.[t]]), l = a.filter(([, t]) => !t).map(([t]) => `VITE_COGNITO_${t}`);
  if (o && l.length !== a.length) {
    if (l.length > 0)
      throw new Error(
        `Incomplete Cognito config. Missing: ${l.join(", ")}`
      );
    return o;
  }
  if (!e)
    throw new Error(
      `Cognito config is required. Missing: ${l.join(", ")}`
    );
  return ue[r] ?? ue.dev;
}
function De(e) {
  if (e === "prod" || e === "qa-legacy") return ".assetwatch.com";
  const { hostname: r } = window.location, o = r.split(".");
  if (o.length >= 5) return "." + o.slice(1).join(".");
  if (o.length === 4) return "." + r;
}
function st(e) {
  Pe.setKeyValueStorage(
    new ve({
      domain: De(e),
      secure: window.location.protocol === "https:",
      sameSite: "lax",
      expires: 30
    })
  );
}
const Me = [
  "Engineering"
];
function qe(e) {
  return e.flatMap((r) => r?.split(/[,;]/) ?? []).map((r) => r.trim()).filter(Boolean);
}
function ct(e, r = Me) {
  if (!e)
    return !1;
  const o = new Set(r);
  return qe([
    e.role,
    ...e.roles ?? [],
    ...e.cognitoGroups ?? []
  ]).some((a) => o.has(a));
}
function We(e) {
  return e.startsWith("http://") || e.startsWith("https://") ? e : `https://${e}`;
}
async function Fe(e) {
  try {
    await j({ global: !0 });
  } finally {
    if (typeof window > "u" || !e?.clientId || !e.domain || !e.redirectUri)
      return;
    const r = new URL(
      "/logout",
      We(e.domain)
    );
    r.searchParams.set("client_id", e.clientId), r.searchParams.set("logout_uri", e.redirectUri), window.location.assign(r.toString());
  }
}
const pe = _e(void 0);
function lt({
  children: e,
  fetchUserData: r,
  validateAuthenticatedUser: o,
  signOutRedirect: a
}) {
  const [l, S] = s(!1), [t, M] = s(!0), [E, I] = s(null), [_, c] = s(null);
  V(() => {
    m();
  }, [r, o]);
  async function m() {
    try {
      const u = await Se();
      if (u.tokens) {
        const N = await Ee(), R = u.tokens.accessToken?.payload?.["cognito:groups"], f = Array.isArray(R) ? R.filter((y) => typeof y == "string") : [], W = await Ie(), k = u.tokens.idToken?.payload?.identities, T = {
          email: N.email || "",
          role: N["custom:role"] || "",
          sub: N.sub || "",
          cognitoGroups: f,
          username: W.username,
          name: typeof u.tokens.idToken?.payload?.name == "string" ? u.tokens.idToken.payload.name : void 0,
          isSsoUser: Array.isArray(k) && k.length > 0
        }, O = r ? await r({ session: u, baseUser: T }) : {}, U = {
          ...T,
          ...O,
          cognitoGroups: O.cognitoGroups ?? T.cognitoGroups
        };
        if (o) {
          const y = await o({
            session: u,
            user: U
          });
          if (!y.ok) {
            await j(), c(y.message), S(!1), I(null);
            return;
          }
        }
        c(null), I(U), S(!0);
      } else
        S(!1), I(null);
    } catch {
      S(!1), I(null);
    } finally {
      M(!1);
    }
  }
  async function C() {
    try {
      c(null), await he();
    } catch (u) {
      if (u instanceof Error && u.name === "UserAlreadyAuthenticatedException")
        await m();
      else
        throw u;
    }
  }
  async function q() {
    await Fe(a);
  }
  const w = {
    isAuthenticated: l,
    isLoading: t,
    validationError: _,
    refreshAuth: m,
    user: E,
    signIn: C,
    signOut: q
  };
  return /* @__PURE__ */ n(pe.Provider, { value: w, children: e });
}
function ut() {
  const e = Ce(pe);
  if (e === void 0)
    throw new Error("useAuth must be used within an AuthProvider");
  return e;
}
const Ge = "_pageShell_6235a_1", Ve = "_card_6235a_14", de = {
  pageShell: Ge,
  card: Ve
}, me = {
  digitRequirement: "contain at least one digit",
  lowercaseRequirement: "contain at least one lowercase letter",
  uppercaseRequirement: "contain at least one uppercase letter",
  specialCharacterRequirement: "contain at least one special character",
  lengthRequirement: "be at least 10 characters in length, but not more than 32",
  previousPasswordRequirement: "not one of your previous 12 passwords (verified after submission)"
};
function ze(e) {
  return e === void 0 ? {
    icon: "warning",
    tone: "warning"
  } : e ? {
    icon: "circle-check",
    tone: "positive"
  } : {
    icon: "circle-xmark-solid",
    tone: "negative"
  };
}
function A({
  children: e,
  isSatisfied: r
}) {
  const { icon: o, tone: a } = ze(r);
  return /* @__PURE__ */ d(z, { align: "start", gap: 8, children: [
    /* @__PURE__ */ n(Re, { "aria-hidden": !0, name: o, size: "sm", tone: a }),
    /* @__PURE__ */ n(D, { size: "sm", tone: "subtext", children: e })
  ] });
}
function je({
  requirements: e,
  isPassedPasswordHistory: r,
  labels: o = me
}) {
  return /* @__PURE__ */ d(g, { gap: 8, children: [
    /* @__PURE__ */ n(A, { isSatisfied: e.hasNumber, children: o.digitRequirement }),
    /* @__PURE__ */ n(A, { isSatisfied: e.hasLowercase, children: o.lowercaseRequirement }),
    /* @__PURE__ */ n(A, { isSatisfied: e.hasUppercase, children: o.uppercaseRequirement }),
    /* @__PURE__ */ n(A, { isSatisfied: e.hasSpecialCharacter, children: o.specialCharacterRequirement }),
    /* @__PURE__ */ n(A, { isSatisfied: e.hasSufficientLength, children: o.lengthRequirement }),
    /* @__PURE__ */ n(A, { isSatisfied: r, children: o.previousPasswordRequirement })
  ] });
}
const Ye = {
  accessibility: {
    assetWatchLogoAriaLabel: "AssetWatch"
  },
  headings: {
    signInTitle: "Sign in",
    signInDescription: "Authenticate with your AssetWatch account.",
    twoFactorTitle: "Two-factor authentication",
    twoFactorDescription: "Enter the code from your authenticator app."
  },
  labels: {
    email: "Email",
    password: "Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    verificationCode: "Verification Code"
  },
  placeholders: {
    email: "Email"
  },
  actions: {
    rememberMe: "Remember me",
    continue: "Continue",
    forgotPassword: "Forgot password?",
    login: "Login",
    loginWithSso: "Login with SSO",
    setNewPassword: "Set New Password",
    changeEmail: "Change Email",
    submit: "Submit"
  },
  loading: {
    checking: "Checking",
    updatingPassword: "Updating password",
    loggingIn: "Logging in",
    verifying: "Verifying",
    redirecting: "Redirecting"
  },
  copy: {
    newPasswordPrompt: "Please enter a new password to replace the temporary one. Your new password must:",
    confirmPasswordMismatch: "Passwords do not match."
  },
  status: {
    passwordUpdatedSuccess: "Password updated successfully. Please log in with your new password.",
    temporaryPasswordUpdatedSuccess: "Temporary password updated successfully. Please log in with your new password."
  },
  errors: {
    invalidEmail: "Please enter a valid email.",
    incorrectEmailOrPassword: "Incorrect email or password.",
    accountNotConfirmed: "Your account isn't confirmed. Please check your email for a verification code.",
    passwordResetRequired: "You must reset your password before signing in. Please use 'Forgot password?' to reset.",
    tooManyAttempts: "Too many attempts. Please wait and try again later.",
    network: "Network error. Please check your connection and try again.",
    generic: "Something went wrong. Please try again.",
    passwordHistoryViolation: "This password was used previously. Please choose a new password that you haven't used in your last 12 passwords.",
    invalidPasswordPolicy: "Password does not meet the policy requirements.",
    updatePasswordGeneric: "Error updating password. Please try again.",
    invalidMfaCode: "Invalid MFA code entered. Please try again.",
    identityProviderUndefined: "Identity provider is not defined.",
    unsupportedSignInStep: "Unsupported sign-in step."
  },
  passwordRequirements: me
}, fe = {
  hasUppercase: !1,
  hasLowercase: !1,
  hasNumber: !1,
  hasSpecialCharacter: !1,
  hasSufficientLength: !1,
  matchesConfirm: !0
}, Q = "sso_post_login_redirect";
function ge(e) {
  return typeof e == "string" && e.startsWith("/") && !e.startsWith("//") && !e.startsWith("/\\");
}
function Be(e) {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})$/.test(
    e
  );
}
function He(e, r) {
  return {
    hasUppercase: e.toLowerCase() !== e,
    hasLowercase: e.toUpperCase() !== e,
    hasNumber: /[0-9]/.test(e),
    hasSpecialCharacter: /[^a-zA-Z0-9]/.test(e),
    hasSufficientLength: e.length >= 10 && e.length <= 32,
    matchesConfirm: e === r
  };
}
function Ke() {
  const e = sessionStorage.getItem(Q);
  return sessionStorage.removeItem(Q), ge(e) ? e : null;
}
function $e(e) {
  sessionStorage.setItem(Q, e);
}
function Ze(e, r) {
  const o = e, a = o.name ?? o.code ?? o.__type?.split("#").pop() ?? "", l = String(o.message ?? "");
  return (a === "NotAuthorizedException" || a === "NotAuthorized") && /incorrect username or password/i.test(l) || a === "UserNotFoundException" ? r.errors.incorrectEmailOrPassword : a === "UserNotConfirmedException" ? r.errors.accountNotConfirmed : a === "PasswordResetRequiredException" ? r.errors.passwordResetRequired : a === "LimitExceededException" || a === "TooManyRequestsException" ? r.errors.tooManyAttempts : /Failed to fetch|NetworkError/i.test(l) ? r.errors.network : r.errors.generic;
}
function Je(e, r) {
  const o = e, a = o.name ?? o.code ?? "", l = String(o.message ?? "");
  return a === "PasswordHistoryPolicyViolationException" ? r.errors.passwordHistoryViolation : a === "InvalidPasswordException" ? r.errors.invalidPasswordPolicy : a === "LimitExceededException" || a === "TooManyRequestsException" ? r.errors.tooManyAttempts : /Failed to fetch|NetworkError/i.test(l) ? r.errors.network : r.errors.updatePasswordGeneric;
}
function dt({
  authenticate: e,
  forgotPasswordHref: r,
  initialEmail: o = "",
  initialStatusMessage: a,
  isAuthenticated: l,
  lookupLoginMethod: S,
  messages: t = Ye,
  onNavigate: M,
  passwordUpdated: E = !1,
  redirectTo: I = "/"
}) {
  const _ = ge(I) ? I : "/", [c, m] = s(""), [C, q] = s(""), [w, u] = s(o), [N, R] = s(null), [f, W] = s(!1), [k, T] = s(), [O, U] = s(!1), [y, b] = s(!1), [X, ee] = s(!1), [Y, te] = s(""), [F, re] = s(""), [we, G] = s(void 0), [B, oe] = s(""), [P, H] = s(
    fe
  ), [ye, h] = s(
    a ? "negative" : E ? "positive" : "informative"
  ), [ne, p] = s(
    a ?? (E ? t.status.passwordUpdatedSuccess : null)
  );
  V(() => {
    const i = localStorage.getItem("rememberMeLogin");
    i && (u(i), ee(!0));
  }, []), V(() => {
    h(
      a ? "negative" : E ? "positive" : "informative"
    ), p(
      a ?? (E ? t.status.passwordUpdatedSuccess : null)
    );
  }, [a, t.status.passwordUpdatedSuccess, E]), V(() => {
    l && M(Ke() ?? _);
  }, [l, M, _]);
  function K() {
    m(""), q(""), W(!1), T(void 0), te(""), re(""), oe(""), H(fe), G(void 0), p(null), h("informative");
  }
  function $() {
    return f ? P.hasUppercase && P.hasLowercase && P.hasNumber && P.hasSpecialCharacter && P.hasSufficientLength && P.matchesConfirm : c === "mfacode" ? Y.length === 6 : w.trim().length > 0 && B.length > 0;
  }
  async function ie() {
    if (!Be(w)) {
      R(t.errors.invalidEmail);
      return;
    }
    R(null);
    const i = w.trim().toLowerCase();
    X ? localStorage.setItem("rememberMeLogin", i) : localStorage.removeItem("rememberMeLogin");
    try {
      U(!0);
      const v = await S(i);
      v.authType === "sso" ? (m("sso"), T(v.identityProvider)) : m("basic");
    } catch {
      m("basic");
    } finally {
      U(!1);
    }
  }
  async function ae() {
    if (f) {
      if (F !== C)
        return;
      b(!0);
      try {
        await ce({ challengeResponse: F }), G(!0), h("positive"), p(t.status.temporaryPasswordUpdatedSuccess), await new Promise((i) => setTimeout(i, 500)), await j(), K();
      } catch (i) {
        G(!1), h("negative"), p(Je(i, t));
      } finally {
        b(!1);
      }
      return;
    }
    if (await j(), b(!0), p(null), h("informative"), c === "mfacode") {
      try {
        await ce({ challengeResponse: Y }), await e();
      } catch {
        h("negative"), p(t.errors.invalidMfaCode);
      } finally {
        b(!1);
      }
      return;
    }
    if (c === "sso") {
      if (!k) {
        h("negative"), p(t.errors.identityProviderUndefined), b(!1);
        return;
      }
      _ !== "/" && $e(_), await he({
        provider: { custom: k },
        customState: JSON.stringify({ isWebLogin: "true" })
      }), b(!1);
      return;
    }
    try {
      switch ((await be({
        username: w.trim().toLowerCase(),
        password: B,
        options: {
          clientMetadata: {
            isWebLogin: "true"
          }
        }
      })).nextStep.signInStep) {
        case "RESET_PASSWORD":
          h("negative"), p(t.errors.passwordResetRequired);
          break;
        case "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED":
          W(!0);
          break;
        case "CONFIRM_SIGN_IN_WITH_TOTP_CODE":
          m("mfacode");
          break;
        case "DONE":
          await e();
          break;
        default:
          h("negative"), p(t.errors.unsupportedSignInStep);
      }
    } catch (i) {
      console.error(
        "[CustomLoginForm.handleSubmit]",
        JSON.stringify({
          message: i instanceof Error ? i.message : String(i),
          name: i instanceof Error ? i.name : void 0
        })
      ), h("negative"), p(Ze(i, t));
    } finally {
      b(!1);
    }
  }
  const se = typeof r == "function" ? r(w.trim().toLowerCase()) : r;
  return /* @__PURE__ */ n("div", { className: de.pageShell, children: /* @__PURE__ */ n(Te, { size: "sm", children: /* @__PURE__ */ n(
    "form",
    {
      className: de.card,
      "data-testid": "login-form",
      noValidate: !0,
      onSubmit: (i) => {
        i.preventDefault(), c === "" ? ie() : (c === "sso" || $()) && ae();
      },
      children: /* @__PURE__ */ d(g, { gap: 24, children: [
        /* @__PURE__ */ d(z, { align: "start", gap: 12, children: [
          /* @__PURE__ */ n(
            Le,
            {
              "aria-label": t.accessibility.assetWatchLogoAriaLabel
            }
          ),
          /* @__PURE__ */ d(g, { gap: 8, children: [
            /* @__PURE__ */ n(le, { as: "h1", size: "xl", children: t.headings.signInTitle }),
            /* @__PURE__ */ n(D, { tone: "subtext", children: t.headings.signInDescription })
          ] })
        ] }),
        ne ? /* @__PURE__ */ n(Ae, { tone: ye, title: ne }) : null,
        /* @__PURE__ */ d(g, { gap: 16, children: [
          c !== "mfacode" ? /* @__PURE__ */ n(
            x,
            {
              autoFocus: !0,
              "data-testid": "email-input",
              disabled: !!c || O,
              error: N ?? void 0,
              label: t.labels.email,
              onChange: (i) => {
                u(i.currentTarget.value), R(null);
              },
              placeholder: t.placeholders.email,
              type: "email",
              value: w
            }
          ) : null,
          c === "" ? /* @__PURE__ */ d(g, { gap: 16, children: [
            /* @__PURE__ */ n(
              Ne,
              {
                checked: X,
                "data-testid": "remember-me",
                label: t.actions.rememberMe,
                onCheckedChange: (i) => ee(!!i),
                size: "md"
              }
            ),
            /* @__PURE__ */ n(
              L,
              {
                "data-testid": "continue-button",
                fullWidth: !0,
                loading: O,
                loadingText: t.loading.checking,
                type: "button",
                onClick: () => {
                  ie();
                },
                children: t.actions.continue
              }
            )
          ] }) : null,
          c === "basic" ? /* @__PURE__ */ d(g, { gap: 12, children: [
            /* @__PURE__ */ n(
              x,
              {
                autoFocus: !f,
                "data-testid": "password-input",
                disabled: f,
                label: t.labels.password,
                onChange: (i) => oe(i.currentTarget.value),
                type: "password",
                value: B
              }
            ),
            !f && se ? /* @__PURE__ */ n(D, { as: "div", size: "sm", children: /* @__PURE__ */ n(ke, { href: se, children: t.actions.forgotPassword }) }) : null
          ] }) : null,
          f ? /* @__PURE__ */ d(g, { gap: 16, children: [
            /* @__PURE__ */ n(D, { tone: "subtext", children: t.copy.newPasswordPrompt }),
            /* @__PURE__ */ n(
              je,
              {
                isPassedPasswordHistory: we,
                labels: t.passwordRequirements,
                requirements: P
              }
            ),
            /* @__PURE__ */ n(
              x,
              {
                "data-testid": "new-password-input",
                label: t.labels.newPassword,
                onChange: (i) => {
                  const v = i.currentTarget.value;
                  re(v), H(
                    He(v, C)
                  ), G(
                    (Z) => Z === !1 ? !1 : void 0
                  );
                },
                type: "password",
                value: F
              }
            ),
            /* @__PURE__ */ n(
              x,
              {
                "data-testid": "confirm-password-input",
                error: C.length > 0 && !P.matchesConfirm ? t.copy.confirmPasswordMismatch : void 0,
                label: t.labels.confirmPassword,
                onChange: (i) => {
                  const v = i.currentTarget.value;
                  q(v), H((Z) => ({
                    ...Z,
                    matchesConfirm: v === F
                  }));
                },
                type: "password",
                value: C
              }
            )
          ] }) : null,
          c === "mfacode" ? /* @__PURE__ */ d(g, { gap: 16, children: [
            /* @__PURE__ */ d(g, { gap: 8, children: [
              /* @__PURE__ */ n(le, { as: "h2", size: "lg", children: t.headings.twoFactorTitle }),
              /* @__PURE__ */ n(D, { tone: "subtext", children: t.headings.twoFactorDescription })
            ] }),
            /* @__PURE__ */ n(
              x,
              {
                autoFocus: !0,
                "data-testid": "mfa-code-input",
                label: t.labels.verificationCode,
                onChange: (i) => te(i.currentTarget.value),
                type: "text",
                value: Y
              }
            )
          ] }) : null,
          c === "basic" ? /* @__PURE__ */ d(z, { grow: !0, children: [
            /* @__PURE__ */ n(
              L,
              {
                "data-testid": "login-button",
                disabled: !$(),
                fullWidth: !0,
                loading: y,
                loadingText: f ? t.loading.updatingPassword : t.loading.loggingIn,
                type: "submit",
                children: f ? t.actions.setNewPassword : t.actions.login
              }
            ),
            /* @__PURE__ */ n(
              L,
              {
                "data-testid": "change-email-button",
                fullWidth: !0,
                type: "button",
                variant: "outline",
                onClick: () => K(),
                children: t.actions.changeEmail
              }
            )
          ] }) : null,
          c === "mfacode" ? /* @__PURE__ */ n(
            L,
            {
              "data-testid": "submit-mfa",
              disabled: !$(),
              fullWidth: !0,
              loading: y,
              loadingText: t.loading.verifying,
              type: "submit",
              children: t.actions.submit
            }
          ) : null,
          c === "sso" ? /* @__PURE__ */ d(z, { grow: !0, children: [
            /* @__PURE__ */ n(
              L,
              {
                "data-testid": "sso-login-button",
                fullWidth: !0,
                loading: y,
                loadingText: t.loading.redirecting,
                type: "button",
                onClick: () => {
                  ae();
                },
                children: t.actions.loginWithSso
              }
            ),
            /* @__PURE__ */ n(
              L,
              {
                "data-testid": "change-email-button",
                fullWidth: !0,
                type: "button",
                variant: "outline",
                onClick: () => K(),
                children: t.actions.changeEmail
              }
            )
          ] }) : null
        ] })
      ] })
    }
  ) }) });
}
function ft({
  apiName: e = "apiVeroUser",
  notProvisionedMessage: r = (o) => `User ${o} not found. Please contact support.`
} = {}) {
  return async ({ user: o }) => {
    const { body: a } = await Oe({
      apiName: e,
      path: "/list",
      options: {
        body: {
          meth: "getCurrentUserInfo"
        }
      }
    }).response;
    return (await a.json()).email ? { ok: !0 } : {
      ok: !1,
      message: r(o.sub)
    };
  };
}
export {
  lt as AuthProvider,
  J as COGNITO_GROUP_NIKOLA_TEAM,
  dt as CustomLoginForm,
  Me as DEFAULT_RELEASE_INFO_ROLES,
  je as PasswordRequirements,
  st as configureSharedCookieAuth,
  ft as createCurrentUserProvisionValidator,
  Ue as isNikolaTeamCognitoGroup,
  it as isNikolaTeamMember,
  ct as isReleaseInfoUser,
  at as resolveAssetWatchCognitoConfig,
  Fe as signOutEverywhere,
  ut as useAuth
};
